export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6380.73f3e464.jpg";